import {
	Component, forwardRef, Input, Output, EventEmitter, ElementRef, OnInit,
	ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const CAPTCHA_CONTROL_VALUE_ACCESSOR: any = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => CaptchaComponent),
	multi: true
};

@Component({
	selector: 'vcm-captcha',
	template: require('./captcha.component.html'),
	providers: [CAPTCHA_CONTROL_VALUE_ACCESSOR],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CaptchaComponent implements ControlValueAccessor {
	@Input('siteKey') siteKey: string = "6Lfq6ZwUAAAAAKC2zT2vRvMW-eGLLiwlX73i9C1Z"; //TODO move to configs
	@Input('theme') theme: string = "light";

	@Output() change: EventEmitter<boolean> = new EventEmitter<boolean>();

	private verified: boolean = null;
	private _controlValueAccessorChangeFn: (value: any) => void = (value) => {};

	constructor(private ref : ChangeDetectorRef) {}

	setVerified(verified: boolean) {
		this.verified = verified;
		this._emitChangeEvent(verified);
	}

	/**
	 * Implemented as part of ControlValueAccessor.
	 */
	writeValue(verified: boolean) {
		this.verified = verified;
		this.ref.markForCheck();
		if (this.verified) {
			this._controlValueAccessorChangeFn(this.verified);
		}
	}

	/**
	 * Implemented as part of ControlValueAccessor.
	 */
	registerOnChange(fn: (value: any) => void) {
		this._controlValueAccessorChangeFn = fn;
	}

	/**
	 * TODO implement if needed
	 */
	registerOnTouched(fn: any) {}

	setDisabledState(isDisabled: boolean) {}

	private _emitChangeEvent(verified: boolean) {
		this._controlValueAccessorChangeFn(this.verified);
		this.change.emit(verified);
	}
}
